import { render, staticRenderFns } from "./ItemSelect.vue?vue&type=template&id=cad2ab96"
import script from "./ItemSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemSelect.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ItemSelect.vue?vue&type=style&index=0&id=cad2ab96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports